var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { class: _vm.$vuetify.breakpoint.xs ? "py-1" : null },
        [
          _c(
            "v-item-group",
            {
              staticClass: "text-center",
              attrs: { value: _vm.value, mandatory: "" },
              on: {
                change: function ($event) {
                  return _vm.$emit("input", $event)
                },
              },
            },
            _vm._l(_vm.length, function (n, idx) {
              return _c("v-item", {
                key: n.name,
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ active, toggle }) {
                        return [
                          _c(
                            "span",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    "input-value": active,
                                    icon: "",
                                    disabled: idx > _vm.value,
                                  },
                                  on: { click: toggle },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex justify-center align-center window-marker",
                                    },
                                    [
                                      _c(
                                        "small",
                                        { staticClass: "white--text" },
                                        [_vm._v(_vm._s(idx + 1))]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }